import React from 'react';
import PropTypes from 'prop-types';

export default class FormInputRadio extends React.Component {
  constructor(props) {
    super(props);

    this.onRadioChange = this.onRadioChange.bind(this);
  }

  onRadioChange = (event) => {
    const { fieldData, userInputHandler } = this.props;

    userInputHandler(fieldData.name, event.currentTarget.value);
  };

  render() {
    const { fieldData, fieldInput } = this.props;

    return (
      <div className="radio-input">
        {fieldData.repeat && fieldData.repeat.map((radio, index) => (
          <label key={`radio-${index + 1}`}>
            <input
              type="radio"
              value={radio.value}
              checked={(fieldInput === '' && index === 0) || (radio.value === fieldInput)}
              onChange={this.onRadioChange}
            />
            {radio.options}
          </label>
        ))}
      </div>
    );
  }
}

FormInputRadio.propTypes = {
  fieldData: PropTypes.shape({
    field_type: PropTypes.string,
    req: PropTypes.string,
    desc_pos: PropTypes.string,
    name: PropTypes.string,
    desc: PropTypes.string,
    placeholder: PropTypes.string,
    email_conf: PropTypes.string,
    value: PropTypes.string,
    repeat: PropTypes.array,
  }).isRequired,
  fieldInput: PropTypes.string.isRequired,
  userInputHandler: PropTypes.func.isRequired,
};
